import { Component, EventEmitter, Input, Output } from '@angular/core'

@Component({
  selector: 'app-confirmation-offer-card',
  templateUrl: './confirmation-offer-card.component.html',
  styleUrls: ['./confirmation-offer-card.component.scss'],
})
export default class ConfirmationOfferCardComponent {
  @Input() imageSrc: string
  @Input() imageAlt = ''
  @Input() imageWidth = 800
  @Input() imageHeight = 500
  @Input() heading: string
  @Input() titleIconSrc?: string
  @Input() text: string
  @Input() linkLabel: string
  @Input() linkUrl?: string

  @Output() linkClick = new EventEmitter<void>()
}
